import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TabViewCategory } from '@ddt-web/config';
import { ComponentData, PortfolioDataUtil, TabData } from '@ddt-web/data-service';
import * as get from 'lodash/get';

@Component({
	selector: 'risk-total-risk-decomposition',
	templateUrl: './total-risk-decomposition.component.html',
	styleUrls: ['./total-risk-decomposition.component.scss']
})
export class TotalRiskDecompositionComponent implements OnChanges, OnInit {
	@Input() public data: ComponentData;

	public asOfDate: string;
	public asOfDateSNP: string;
	public activeTotalTab: TabData;
	public totalTab: TabData;
	public parentCollapsed: Array<boolean> = [];
	public subTitle: string;
	public title: string;
	public totalRiskDecompositionTabs: Array<{ [key: string]: TabData }> = [];
	public readonly tabViewCategory: any = TabViewCategory;
	// comparator to show portfolio tab first
	public tabNameComparator = (a, b): number => {
		return a === 'portfolio' ? -1 : 1;
	};

	constructor(private contentService: ContentService) { }

	public ngOnInit(): void {
		this.subTitle = this.contentService.get('TOTAL_RISK_DECOMPOSITION_SUBTITLE', 'TOTAL_RISK_DECOMPOSITION_SUBTITLE');
		this.title = this.contentService.get('TOTAL_RISK_DECOMPOSITION_TITLE', 'Risk Decomposition - Total Portfolio');
	}

	public ngOnChanges(): void {
		if (this.data.success) {
			const tabs = get(this.data, 'tabs', []);
			const asOfDateTab = tabs.find(tab => tab.config.id === 'risk.asOfDate');
			this.asOfDate = get(asOfDateTab, 'displayConfig.visible') && get(asOfDateTab, 'tableData[0].cells[0][0].formattedValue');
			const asOfDateSNPTab = tabs.find(tab => tab.config.id === 'risk.asOfDate.snp');
			this.asOfDateSNP = get(asOfDateSNPTab, 'displayConfig.visible') && get(asOfDateSNPTab, 'tableData[0].cells[0][0].formattedValue');
			this.activeTotalTab = tabs.find(tab => tab.config.id === 'total.active.risk.sum');
			this.totalTab = tabs.find(tab => tab.config.id === 'total.risk.sum');
			const iterativeTabs = tabs.filter(tab => get(tab, 'displayConfig.isIterative'));
			this.totalRiskDecompositionTabs = PortfolioDataUtil.getTabsDataByCategory(iterativeTabs, '.active', ['.risk.decomposition']);
		}
	}
}
